// The screens this app has, generated from .appfactory/product-plan.json.
//
// Imported by the navigation shell rather than replacing it: the shell owns
// router.js — bottom-tabs, stack and sidebar produce different routers, and it
// rewrites that file on every `spec apply`. Two owners for one file is a silent
// fight, so the product contributes ROUTES and the shell decides what to do
// with them.
//
// `primary` marks a screen that earns a place in the navigation itself.

import WritePage from './pages/WritePage.vue';
import AlphabetPage from './pages/AlphabetPage.vue';
import DecodePage from './pages/DecodePage.vue';
import SavedPage from './pages/SavedPage.vue';
import SettingsPage from './pages/SettingsPage.vue';
import MessageDetailPage from './pages/MessageDetailPage.vue';

export const PRODUCT_ROUTES = [
  {
    id: 'write',
    path: '/',
    label: 'Write',
    component: WritePage,
    primary: true,
  },
  {
    id: 'alphabet',
    path: '/alphabet',
    label: 'Alphabet',
    component: AlphabetPage,
    primary: false,
  },
  {
    id: 'decode',
    path: '/decode',
    label: 'Decode',
    component: DecodePage,
    primary: false,
  },
  {
    id: 'saved',
    path: '/kept',
    label: 'Kept',
    component: SavedPage,
    primary: false,
  },
  {
    id: 'settings',
    path: '/settings',
    label: 'Settings',
    component: SettingsPage,
    primary: false,
  },
  {
    id: 'message-detail',
    path: '/messages/:id',
    label: 'Message',
    component: MessageDetailPage,
    primary: false,
  },
];

export const PRIMARY_ROUTES = PRODUCT_ROUTES.filter((r) => r.primary);
export const HOME_ROUTE = (PRIMARY_ROUTES[0] ?? PRODUCT_ROUTES[0])?.path ?? '/';
